import { RootState } from "store";

export const selectStripeSubscribeStatus = (state: RootState) => ({
  info: state.userSettingState.stripeSubscription,
  history: state.userSettingState.subscriptionHistory ?? []
});
